var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8641 20C10.3173 20 9.77053 20 9.22375 20C9.19108 19.9869 9.15913 19.9673 9.12427 19.9622C8.77718 19.9107 8.42719 19.8773 8.083 19.8105C2.6254 18.744 -0.926097 13.4019 0.212476 7.97702C1.52968 1.69909 8.33497 -1.77349 14.144 0.922243C17.3884 2.42657 19.293 5.01194 19.8921 8.5455C19.9284 8.75895 19.9647 8.97241 20.001 9.18513C20.001 9.7449 20.001 10.3047 20.001 10.8637C19.9865 10.9094 19.9632 10.9537 19.9589 11.0009C19.7701 12.8116 19.1601 14.4655 18.0687 15.9248C16.419 18.129 14.2304 19.4591 11.5031 19.8896C11.2896 19.9238 11.0768 19.963 10.8641 20Z",
    fill: "#FF3131"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 15L9 15L9 13L11 13L11 15ZM11 11L9 11L9 5L11 5L11 11Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcError);
export default __webpack_public_path__ + "static/media/ic-error.dad0124bab535b83bafe2bfb6e03335b.svg";
export { ForwardRef as ReactComponent };